module.exports = __webpack_public_path__ + "static/media/logo-play-horizontal.9610a826.svg";